// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9567696f","732":"cfba9896","977":"bfccf2c8"}[chunkId] + ".chunk.js";
};